module.exports = __webpack_public_path__ + "static/media/editBtn.6e093eba.svg";